
function rateRequestDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/rate-request/rate-request-dialog.html?$$REVISION$$'
  }
}

export { rateRequestDialogDirective }
